// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"50":"datadogProfiler","133":"datadogRecorder"}[chunkId] + ".js";
};